var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonhumanIdentityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24 ",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1057",
    d: "M10.0625 15.5558C10.0625 15.1809 10.3149 14.877 10.6261 14.877H13.3812C13.6925 14.877 13.9449 15.1809 13.9449 15.5558C13.9449 15.9308 13.6925 16.2347 13.3812 16.2347H10.6261C10.3149 16.2347 10.0625 15.9308 10.0625 15.5558Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 70",
    d: "M17.0969 11.6646C17.0969 12.5678 16.3647 13.3 15.4615 13.3C14.5583 13.3 13.8262 12.5678 13.8262 11.6646C13.8262 10.7615 14.5583 10.0293 15.4615 10.0293C16.3647 10.0293 17.0969 10.7615 17.0969 11.6646Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 76",
    d: "M10.173 11.6939C10.173 12.5971 9.44086 13.3293 8.53768 13.3293C7.63451 13.3293 6.90234 12.5971 6.90234 11.6939C6.90234 10.7908 7.63451 10.0586 8.53768 10.0586C9.44086 10.0586 10.173 10.7908 10.173 11.6939Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1059",
    x: 4.48438,
    y: 7.47656,
    width: 15.0371,
    height: 10.9785,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.793 5.03517C13.6334 4.68106 14.2235 3.84957 14.2235 2.88028C14.2235 1.58942 13.177 0.542969 11.8861 0.542969C10.5953 0.542969 9.54883 1.58942 9.54883 2.88028C9.54883 3.84776 10.1366 4.67795 10.9746 5.03318V7.25781H12.793V5.03517ZM11.8861 3.64756C11.4624 3.64756 11.1189 3.30404 11.1189 2.88028C11.1189 2.45653 11.4624 2.11301 11.8861 2.11301C12.3099 2.11301 12.6534 2.45653 12.6534 2.88028C12.6534 3.30404 12.3099 3.64756 11.8861 3.64756Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8291 16.2344C3.04821 16.2344 2.29931 15.9204 1.74714 15.3614C1.19497 14.8025 0.884766 14.0444 0.884766 13.2539C0.884766 12.4634 1.19497 11.7053 1.74714 11.1464C2.29931 10.5875 3.04822 10.2734 3.8291 10.2734V11.7556C3.43654 11.7556 3.06005 11.9134 2.78247 12.1944C2.50488 12.4754 2.34894 12.8565 2.34894 13.2539C2.34894 13.6513 2.50488 14.0324 2.78247 14.3134C3.06005 14.5944 3.43654 14.7522 3.8291 14.7522L3.8291 16.2344Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8291 16.2344C3.04821 16.2344 2.29931 15.9204 1.74714 15.3614C1.19497 14.8025 0.884766 14.0444 0.884766 13.2539C0.884766 12.4634 1.19497 11.7053 1.74714 11.1464C2.29931 10.5875 3.04822 10.2734 3.8291 10.2734V11.7556C3.43654 11.7556 3.06005 11.9134 2.78247 12.1944C2.50488 12.4754 2.34894 12.8565 2.34894 13.2539C2.34894 13.6513 2.50488 14.0324 2.78247 14.3134C3.06005 14.5944 3.43654 14.7522 3.8291 14.7522L3.8291 16.2344Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1709 16.2344C20.9518 16.2344 21.7007 15.9204 22.2529 15.3614C22.805 14.8025 23.1152 14.0444 23.1152 13.2539C23.1152 12.4634 22.805 11.7053 22.2529 11.1464C21.7007 10.5875 20.9518 10.2734 20.1709 10.2734V11.7556C20.5635 11.7556 20.9399 11.9134 21.2175 12.1944C21.4951 12.4754 21.6511 12.8565 21.6511 13.2539C21.6511 13.6513 21.4951 14.0324 21.2175 14.3134C20.9399 14.5944 20.5635 14.7522 20.1709 14.7522L20.1709 16.2344Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1709 16.2344C20.9518 16.2344 21.7007 15.9204 22.2529 15.3614C22.805 14.8025 23.1152 14.0444 23.1152 13.2539C23.1152 12.4634 22.805 11.7053 22.2529 11.1464C21.7007 10.5875 20.9518 10.2734 20.1709 10.2734V11.7556C20.5635 11.7556 20.9399 11.9134 21.2175 12.1944C21.4951 12.4754 21.6511 12.8565 21.6511 13.2539C21.6511 13.6513 21.4951 14.0324 21.2175 14.3134C20.9399 14.5944 20.5635 14.7522 20.1709 14.7522L20.1709 16.2344Z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonhumanIdentityIcon);
export default __webpack_public_path__ + "static/media/nonhuman_identity_icon.ebc8196b14084ac7578f56fbe26da47d.svg";
export { ForwardRef as ReactComponent };